import React from "react";
import classes from './Modal.module.css'

const Modal = ({ children ,onClose,dropStyle,title,dropClass}) => {

    return (
        <div className={classes.BackdropPopupContainer} onClick={onClose}>
            <div className={`${classes.BackdropPopup} ${dropClass}`} style={dropStyle}  onClick={(e)=>e.stopPropagation()}>
                <div className={classes.Close}  onClick={onClose}>x</div>
                {title && <div className={classes.Tilte}>{title}</div>}
                {children}
            </div>
        </div>
    )
}

export default Modal;